import axios from 'axios'
import request from '@/utils/request'

// 登录相关
export function getCaptcha() {
    return request({ url: '/auth/captcha', method: 'get' })
}
export function login(data) {
    return request({ url: '/auth/login', method: 'post', data })
}
export function getUserRoutes() {
    return request({ url: '/menu/user-routes', method: 'get' })
}
// 获取菜单列表
export function getMenuList() {
    return request({ url: '/menu/list', method: 'get' })
}

// 保存菜单 (新增或修改)
export function saveMenu(data) {
    return request({ url: '/menu/save', method: 'post', data })
}

// 删除菜单
export function deleteMenu(data) {
    return request({ url: '/menu/delete', method: 'post', data })
}

// 用户相关
export function getUserList(params) {
    return request({ url: '/user/list', method: 'get', params })
}
export function addUser(data) {
    return request({ url: '/user/add', method: 'post', data })
}
export function updateUser(data) {
    return request({ url: '/user/update', method: 'put', data })
}
export function deleteUser(data) {
    return request({ url: '/user/delete', method: 'post', data })
}
export function resetUserPassword(data) {
    return request({ url: '/user/reset-password', method: 'post', data })
}
export function getUser(id) {
    return request({ url: `/user/${id}`, method: 'get' })
}
// 角色列表（添加用户时用）
export function getRoleList() {
    return request({ url: '/role/list', method: 'get' })
}
export function deleteRole(data) {
    return request({ url: '/role/delete', method: 'post', data })
}






// === 首页组件管理 (CMS) ===

// 1. 获取组件列表
export function getCmsComponents() {
    return request({ url: '/cms/home/list', method: 'get' })
}

// 2. 保存/更新组件
export function saveCmsComponent(data) {
    return request({ url: '/cms/home/save', method: 'post', data })
}

// 3. 保存排序 (拖拽后调用)
// data 格式示例: [3, 1, 5, 2] (ID数组)
export function sortCmsComponents(data) {
    return request({ url: '/cms/home/sort', method: 'post', data })
}

// 4. 删除组件
export function deleteCmsComponent(data) {
    return request({ url: '/cms/home/delete', method: 'post', data })
}
// === 产品管理 ===
export function getProductList(params) {
    return request({ url: '/product/list', method: 'get', params })
}
export function getProduct(id) {
    return request({ url: `/product/${id}`, method: 'get' })
}
export function saveProduct(data) {
    return request({ url: '/product/save', method: 'post', data })
}
export function deleteProduct(data) {
    return request({ url: '/product/delete', method: 'post', data })
}

// === 字典管理 ===
export function getDictList(params) {
    return request({ url: '/dict/list', method: 'get', params })
}
export function saveDict(data) {
    return request({ url: '/dict/save', method: 'post', data })
}
export function deleteDict(data) {
    return request({ url: '/dict/delete', method: 'post', data })
}

// === 日志管理 ===
export function getLogList(params) {
    return request({ url: '/log/list', method: 'get', params })
}

// === 龙舟赛事管理 ===
export function getDragonEventList(params) {
    return request({ url: '/dragonboat/event/list', method: 'get', params })
}
export function getDragonEventDetail(params) {
    return request({ url: '/dragonboat/event/detail', method: 'get', params })
}
export function getDragonEventMiniProgramCode(id) {
    const base = process.env.VUE_APP_API_BASE_URL || '/api'
    const token = localStorage.getItem('token')
    return axios.get(`${base}/dragonboat/event/mini-program-code`, {
        params: { id },
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token || ''}` }
    })
}
export function saveDragonEvent(data) {
    return request({ url: '/dragonboat/event/save', method: 'post', data })
}
export function deleteDragonEvent(data) {
    return request({ url: '/dragonboat/event/delete', method: 'post', data })
}
export function getDragonCategoryList(params) {
    return request({ url: '/dragonboat/event/category/list', method: 'get', params })
}
export function saveDragonCategory(data) {
    return request({ url: '/dragonboat/event/category/save', method: 'post', data })
}
export function deleteDragonCategory(data) {
    return request({ url: '/dragonboat/event/category/delete', method: 'post', data })
}
export function getDragonTeamList(params) {
    return request({ url: '/dragonboat/team/list', method: 'get', params })
}
export function auditDragonTeam(data) {
    return request({ url: '/dragonboat/team/audit', method: 'post', data })
}
export function getDragonTeamProfile(params) {
    return request({ url: '/dragonboat/team/profile', method: 'get', params })
}
export function auditDragonTeamProfile(data) {
    return request({ url: '/dragonboat/team/profile/audit', method: 'post', data })
}
export function deleteDragonTeam(data) {
    return request({ url: '/dragonboat/team/delete', method: 'post', data })
}
export function saveDragonTeam(data) {
    return request({ url: '/dragonboat/team/save', method: 'post', data })
}
export function getDragonMemberList(params) {
    return request({ url: '/dragonboat/member/list', method: 'get', params })
}
export function reviewDragonMember(data) {
    return request({ url: '/dragonboat/member/review', method: 'post', data })
}
export function updateDragonMember(data) {
    return request({ url: '/dragonboat/member/update', method: 'post', data })
}
export function addDragonMember(data) {
    return request({ url: '/dragonboat/member/add', method: 'post', data })
}
export function deleteDragonMember(data) {
    return request({ url: '/dragonboat/member/delete', method: 'post', data })
}
export function getDragonRegistrationList(params) {
    return request({ url: '/dragonboat/registration/list', method: 'get', params })
}
export function getDragonRegistrationRoundLineups(params) {
    return request({ url: '/dragonboat/registration/round-lineups', method: 'get', params })
}
export function auditDragonRegistration(data) {
    return request({ url: '/dragonboat/registration/audit', method: 'post', data })
}
export function addDragonRegistrationTeam(data) {
    return request({ url: '/dragonboat/registration/add-team', method: 'post', data })
}
export function deleteDragonRegistration(data) {
    return request({ url: '/dragonboat/registration/delete', method: 'post', data })
}
export function updateDragonRegistrationMember(data) {
    return request({ url: '/dragonboat/registration/member/update', method: 'post', data })
}
export function addDragonRegistrationMember(data) {
    return request({ url: '/dragonboat/registration/member/add', method: 'post', data })
}
export function removeDragonRegistrationMember(data) {
    return request({ url: '/dragonboat/registration/member/remove', method: 'post', data })
}
export function getDragonScoringRule(params) {
    return request({ url: '/dragonboat/scoring/rule', method: 'get', params })
}
export function saveDragonScoringRule(data) {
    return request({ url: '/dragonboat/scoring/rule/save', method: 'post', data })
}
export function recalcDragonScoring(data) {
    return request({ url: '/dragonboat/scoring/recalculate', method: 'post', data })
}
export function getDragonRanking(params) {
    return request({ url: '/dragonboat/scoring/ranking', method: 'get', params })
}
export function getDragonDashboardStats() {
    return request({ url: '/dragonboat/dashboard/stats', method: 'get' })
}
export function getDragonAthleteList(params) {
    return request({ url: '/dragonboat/athlete/list', method: 'get', params })
}
export function getDragonAthleteDetail(params) {
    return request({ url: '/dragonboat/athlete/detail', method: 'get', params })
}
export function updateDragonAthleteStatus(data) {
    return request({ url: '/dragonboat/athlete/status', method: 'post', data })
}
export function saveDragonAthlete(data) {
    return request({ url: '/dragonboat/athlete/save', method: 'post', data })
}
export function deleteDragonAthlete(data) {
    return request({ url: '/dragonboat/athlete/delete', method: 'post', data })
}
export function getDragonResultList(params) {
    return request({ url: '/dragonboat/result/list', method: 'get', params })
}
export function getDragonResultTeamOptions(params) {
    return request({ url: '/dragonboat/result/team-options', method: 'get', params })
}
export function saveDragonResult(data) {
    return request({ url: '/dragonboat/result/save', method: 'post', data })
}
export function deleteDragonResult(data) {
    return request({ url: '/dragonboat/result/delete', method: 'post', data })
}
export function publishDragonResult(data) {
    return request({ url: '/dragonboat/result/publish', method: 'post', data })
}
export function getDragonStatistics(params) {
    return request({ url: '/dragonboat/result/statistics', method: 'get', params })
}
export function getDragonNoticeList(params) {
    return request({ url: '/dragonboat/notice/list', method: 'get', params })
}

// === 龙舟赛事分组管理 ===
export function getDragonGroupList(params) {
    return request({ url: '/dragonboat/group/list', method: 'get', params })
}
export function getDragonGroupOptions() {
    return request({ url: '/dragonboat/group/options', method: 'get' })
}
export function saveDragonGroup(data) {
    return request({ url: '/dragonboat/group/save', method: 'post', data })
}
export function deleteDragonGroup(data) {
    return request({ url: '/dragonboat/group/delete', method: 'post', data })
}

// === 龙舟赛事轮次管理 ===
export function getDragonRoundList(params) {
    return request({ url: '/dragonboat/round/list', method: 'get', params })
}
export function getDragonRoundOptions(params) {
    return request({ url: '/dragonboat/round/options', method: 'get', params })
}
export function saveDragonRound(data) {
    return request({ url: '/dragonboat/round/save', method: 'post', data })
}
export function deleteDragonRound(data) {
    return request({ url: '/dragonboat/round/delete', method: 'post', data })
}
export function batchSaveDragonResults(data) {
    return request({ url: '/dragonboat/result/batch-save', method: 'post', data })
}
export function importDragonResultWorkbook(eventId, data) {
    return request({
        url: `/dragonboat/result/import-workbook?eventId=${eventId}`,
        method: 'post',
        data,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// === 龙舟赛事阶段配置 ===
export function getDragonStageConfigList(params) {
    return request({ url: '/dragonboat/stage/list', method: 'get', params })
}
export function saveDragonStageConfig(data) {
    return request({ url: '/dragonboat/stage/save', method: 'post', data })
}
export function deleteDragonStageConfig(data) {
    return request({ url: '/dragonboat/stage/delete', method: 'post', data })
}

// === 龙舟赛事距离配置 ===
export function getDragonDistanceConfigList(params) {
    return request({ url: '/dragonboat/distance/list', method: 'get', params })
}
export function saveDragonDistanceConfig(data) {
    return request({ url: '/dragonboat/distance/save', method: 'post', data })
}
export function deleteDragonDistanceConfig(data) {
    return request({ url: '/dragonboat/distance/delete', method: 'post', data })
}

// === 实名认证体系 ===
export function generateInviteCodes(data) {
    return request({ url: '/dragonboat/auth/invite-codes/generate', method: 'post', data })
}
export function getInviteCodes(params) {
    return request({ url: '/dragonboat/auth/invite-codes', method: 'get', params })
}
export function getAuthVerifications(params) {
    return request({ url: '/dragonboat/auth/list', method: 'get', params })
}
export function reviewAuthVerification(data) {
    return request({ url: '/dragonboat/auth/review', method: 'post', data })
}
export function revokeAuthVerification(data) {
    return request({ url: '/dragonboat/auth/revoke', method: 'post', data })
}
export function exportAuthVerifications(params) {
    return request({ url: '/dragonboat/auth/export', method: 'get', params })
}
export function getAuthVerificationFile(attachmentId) {
    const baseURL = process.env.VUE_APP_API_BASE_URL || '/api'
    return axios.get(`${baseURL}/dragonboat/auth/files/${attachmentId}`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` }
    })
}

export function searchVerifiedUsers(params) {
    return request({ url: '/dragonboat/user/verified-search', method: 'get', params })
}

export function getDashboardTodo() {
    return request({ url: '/dragonboat/dashboard/todo', method: 'get' })
}

export function getLeaderTransfers(params) {
    return request({ url: '/admin-app/leader-transfer/list', method: 'get', params })
}

export function reviewLeaderTransfer(data) {
    return request({ url: '/admin-app/leader-transfer/review', method: 'post', data })
}
export function getInviteCodeBatches(params) {
    return request({ url: '/dragonboat/auth/invite-codes/batches', method: 'get', params })
}
export function getInviteCodesByBatch(params) {
    return request({ url: '/dragonboat/auth/invite-codes/detail', method: 'get', params })
}
export function voidInviteCodeBatch(data) {
    return request({ url: '/dragonboat/auth/invite-codes/void-batch', method: 'post', data })
}

// 成绩导出（blob 直下，绕过统一拦截器）
export function exportDragonResults(params) {
    const base = process.env.VUE_APP_API_BASE_URL || '/api'
    const token = localStorage.getItem('token')
    return axios.get(`${base}/dragonboat/result/export`, { params, responseType: 'blob', headers: { Authorization: `Bearer ${token}` } })
        .then(res => res.data)
        .catch(err => {
            if (err.response && err.response.status === 401) {
                localStorage.removeItem('token')
                window.location.href = '/login'
            }
            throw err
        })
}
export function getCancelRequests(params) {
    return request({ url: '/dragonboat/auth/cancel-list', method: 'get', params })
}
export function reviewCancelRequest(data) {
    return request({ url: '/dragonboat/auth/cancel-review', method: 'post', data })
}
